import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Parts} from "components";
import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Help Desks',
	url: '/helpdesks',
	icon: 'comments'
}];

class HelpDesks extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history, roles} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Random",
				url: `/helpdesks/random`,
				icon: 'laptop',
			}
		]);

		return (
			<div className={'container-fluid'}>
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Parts.Tickers.HelpdeskTicker/>

				<Collections.HelpDesksRandom
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					showCSV={roles.includes(UserRoles.Admin)}
					roles={roles}
				/>
			</div>

		)
	}
}

export default Framework.Components.withRootState(HelpDesks);
